import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { computed } from 'vue'
import { hfmath } from './hfmath'


export default /*#__PURE__*/_defineComponent({
  __name: 'SymbolContent',
  props: {
  latex: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props



const svg = computed(() => {
  const eq = new hfmath(props.latex)
  return eq.svg({
    SCALE_X: 10,
    SCALE_Y: 10,
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "symbol-content",
    innerHTML: _unref(svg)
  }, null, 8, _hoisted_1))
}
}

})